import { FC } from "react"
import { Layout } from "../../components/LandingPage/Layout"

export const LandingPage: FC = () => {
  return <Layout />
}
